(function () {
  var TOKEN_URL = 'https://global.shokz.com/lottery/start';
  var DRAW_URL = 'https://global.shokz.com/lottery/openapi_v3';
  var lotteryTokenPromise = null;
  var lotteryTokenEmail = '';

  var ACT_STATUS_MESSAGES = {
    no_finish: 'このメールアドレスではすでに応募済みです。',
    no_finish_ip: '同一IPアドレスからの応募上限に達しました。',
    no_login: '応募できませんでした。メールアドレスをご確認のうえ、再度お試しください。',
    no_act: '現在このキャンペーンはご利用いただけません。',
    sign_invalid: 'エラーが発生しました。時間をおいて再度お試しください。',
  };

  var DEFAULT_ERROR_MESSAGE = 'エラーが発生しました。時間をおいて再度お試しください。';
  function getGiftRoot() {
    return document.querySelector('[data-jojo-campaign-gift]');
  }

  function getLotterySign() {
    var el = document.getElementById('jojo-campaign-gift-lottery-sign');
    var sign = el ? String(el.textContent || '').trim() : '';
    if (!sign) throw new Error('Lottery sign missing');
    return sign;
  }

  function getLotteryActId(root) {
    var node = root || getGiftRoot();
    var actIdRaw = node ? String(node.getAttribute('data-lottery-act-id') || '').trim() : '';
    if (!actIdRaw) throw new Error('Lottery actId missing');
    return /^\d+$/.test(actIdRaw) ? Number(actIdRaw) : actIdRaw;
  }

  function getLotteryUrls(root) {
    var node = root || getGiftRoot();
    return {
      tokenUrl: (node && node.getAttribute('data-lottery-token-url')) || TOKEN_URL,
      drawUrl: (node && node.getAttribute('data-lottery-draw-url')) || DRAW_URL,
      usageScenarios: (node && node.getAttribute('data-lottery-usage')) || 'cs',
    };
  }

  async function parseJsonResponse(response, errorPrefix) {
    try {
      return await response.json();
    } catch (error) {
      throw new Error(errorPrefix + ' HTTP ' + response.status);
    }
  }

  // Step 1: POST actId + sign → token
  async function fetchLotteryToken(actId, sign, email) {
    var mbId = String(email || '').trim();
    if (!mbId) throw new Error('Lottery email missing');

    var urls = getLotteryUrls();
    var response = await fetch(urls.tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        actId: actId,
        sign: sign,
      }),
    });
    var result = await parseJsonResponse(response, 'Lottery token response was not JSON.');
    var token = result && result.data && result.data.token;
    if (Number(result && result.code) !== 200 || !token) {
      var actStatus = result && result.data ? result.data.act_status : '';
      throw new Error(actStatus || (result && result.msg) || 'Lottery token failed');
    }
    return token;
  }

  // Cache token per email so draw can reuse a prefetch
  function prefetchLotteryToken(email) {
    var mbId = String(email || '').trim();
    if (!mbId) {
      return Promise.reject(new Error('Lottery email missing'));
    }
    if (!lotteryTokenPromise || lotteryTokenEmail !== mbId) {
      lotteryTokenEmail = mbId;
      lotteryTokenPromise = fetchLotteryToken(
        getLotteryActId(),
        getLotterySign(),
        mbId
      ).catch(function (error) {
        lotteryTokenPromise = null;
        lotteryTokenEmail = '';
        throw error;
      });
    }
    return lotteryTokenPromise;
  }

  // Step 2: POST mbId + actId + sign + token → prize
  async function drawLottery(email) {
    var mbId = String(email || '').trim();
    if (!mbId) throw new Error('email is required');

    var root = getGiftRoot();
    if (!root) throw new Error('Gift section root not found');

    var urls = getLotteryUrls(root);
    var actId = getLotteryActId(root);
    var sign = getLotterySign();
    var token = await prefetchLotteryToken(mbId);

    var response = await fetch(urls.drawUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        mbId: mbId,
        actId: actId,
        usageScenarios: urls.usageScenarios,
        sign: sign,
        token: token,
      }),
    });

    var drawResult = await parseJsonResponse(response, 'Lottery response was not JSON.');
    return {
      token: token,
      drawResult: drawResult,
      httpOk: response.ok,
      status: response.status,
    };
  }

  window.jojoCampaignGiftPrefetchToken = function (email) {
    return prefetchLotteryToken(email);
  };

  window.jojoCampaignGiftDrawTest = async function (email) {
    try {
      var payload = await drawLottery(email);
      console.log('[jojoCampaignGiftDrawTest]', payload);
      return payload;
    } catch (error) {
      console.error('[jojoCampaignGiftDrawTest]', error);
      throw error;
    }
  };

  function bindTermsGate(root) {
    var embed = root.querySelector('.jojo-campaign-gift__embed');
    if (!embed || embed.dataset.jojoGiftGateReady === 'true') return;
    embed.dataset.jojoGiftGateReady = 'true';

    var bound = false;

    function sync() {
      var button = embed.querySelector('button.klaviyo-form-button');
      var checkboxes = embed.querySelectorAll('input[type="checkbox"]');
      if (!button || !checkboxes.length) return false;

      var allowed = Array.prototype.every.call(checkboxes, function (box) {
        return box.checked;
      });

      button.disabled = !allowed;
      button.setAttribute('aria-disabled', allowed ? 'false' : 'true');
      button.classList.toggle('is-locked', !allowed);
      return true;
    }

    function onChange() {
      sync();
    }

    function bindOnce() {
      if (!sync()) return false;
      if (bound) return true;
      bound = true;

      Array.prototype.forEach.call(
        embed.querySelectorAll('input[type="checkbox"]'),
        function (box) {
          box.addEventListener('change', onChange);
          box.addEventListener('click', onChange);
        }
      );

      embed.addEventListener(
        'click',
        function (event) {
          var button = event.target.closest('button.klaviyo-form-button');
          if (!button || !embed.contains(button)) return;
          if (button.disabled || button.classList.contains('is-locked')) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );

      return true;
    }

    if (bindOnce()) return;

    var observer = new MutationObserver(function () {
      if (bindOnce()) observer.disconnect();
    });
    observer.observe(embed, { childList: true, subtree: true });

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (bindOnce() || tries > 40) clearInterval(timer);
    }, 250);
  }

  function getEmailFromEmbed(root) {
    var embed = root.querySelector('.jojo-campaign-gift__embed');
    if (!embed) return '';
    var emailInput =
      embed.querySelector('input[type="email"]') ||
      embed.querySelector('input[name="email"]') ||
      embed.querySelector('input[autocomplete="email"]') ||
      embed.querySelector('input');
    return emailInput ? String(emailInput.value || '').trim() : '';
  }

  function getSubmittedEmail(detail, root) {
    var meta = (detail && detail.metaData) || {};
    var fromEvent = String(meta.$email || meta.email || '').trim();
    if (fromEvent) return fromEvent;
    return getEmailFromEmbed(root);
  }

  function getDrawPriceName(drawData) {
    return String(
      (drawData && (drawData.priceName || drawData.price_name)) || ''
    ).trim();
  }

  function normalizePrizeKey(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parseMatchTokens(raw) {
    return String(raw || '')
      .split(',')
      .map(function (token) {
        return normalizePrizeKey(token);
      })
      .filter(Boolean);
  }

  function isLoseKey(key) {
    return key === '5' || key === 'lose';
  }

  // API priceName is the source of truth (e.g. "1" / "2" / "3" / "4" / "5").
  function panelMatchesPriceName(panel, priceName) {
    var name = normalizePrizeKey(priceName);
    if (!name) return false;

    var prizeKey = normalizePrizeKey(panel.getAttribute('data-prize-key'));
    if (prizeKey && prizeKey === name) return true;

    var tokens = parseMatchTokens(panel.getAttribute('data-lottery-match'));
    return tokens.some(function (token) {
      return token === name;
    });
  }

  function resolvePrizePanel(panels, drawData) {
    var priceName = getDrawPriceName(drawData);
    var byKey = {};
    var losePanel = null;

    panels.forEach(function (panel) {
      var key = normalizePrizeKey(panel.getAttribute('data-prize-key'));
      if (key && !byKey[key]) byKey[key] = panel;
      if (!losePanel && isLoseKey(key)) losePanel = panel;
    });

    if (priceName) {
      for (var i = 0; i < panels.length; i++) {
        if (panelMatchesPriceName(panels[i], priceName)) return panels[i];
      }
    }

    return losePanel || byKey['5'] || byKey.lose || panels[panels.length - 1] || null;
  }

  function bindResultModal(root) {
    var result = root.querySelector('[data-jojo-gift-result]');
    var notice = root.querySelector('[data-jojo-gift-draw-notice]');
    var embed = root.querySelector('.jojo-campaign-gift__embed');
    var panels = result
      ? Array.prototype.slice.call(result.querySelectorAll('[data-jojo-gift-result-panel]'))
      : [];

    var formId = root.getAttribute('data-klaviyo-form-id') || '';
    var dialog = result ? result.querySelector('.jojo-campaign-gift__result-dialog') : null;
    var closeEls = result ? result.querySelectorAll('[data-jojo-gift-result-close]') : [];
    var lastFocus = null;
    var open = false;
    var drawing = false;
    var successObserver = null;
    var successObserverTimer = null;

    function hideNotice() {
      if (!notice) return;
      notice.setAttribute('hidden', '');
      notice.textContent = '';
      notice.classList.remove('is-visible');
    }

    function showNotice(message) {
      if (!notice) {
        console.warn('[jojo-campaign-gift]', message);
        return;
      }
      notice.textContent = message;
      notice.removeAttribute('hidden');
      notice.classList.add('is-visible');
    }

    function rowHasInteractive(row) {
      return !!(
        row &&
        row.querySelector(
          'input, button, textarea, select, .klaviyo-checkboxes, .klaviyo-form-button'
        )
      );
    }

    function stopSuccessObserver() {
      if (successObserver) {
        successObserver.disconnect();
        successObserver = null;
      }
      if (successObserverTimer) {
        clearTimeout(successObserverTimer);
        successObserverTimer = null;
      }
    }

    // Hide Klaviyo thank-you UI; keep email/checkbox/button rows when possible.
    function suppressKlaviyoSuccess() {
      if (!embed) return;
      embed.classList.add('is-draw-error');
      embed.classList.remove('is-draw-success');

      function apply() {
        var rows = embed.querySelectorAll('[data-testid="form-row"]');
        Array.prototype.forEach.call(rows, function (row) {
          if (rowHasInteractive(row)) {
            row.removeAttribute('data-jojo-gift-klaviyo-success');
            row.style.removeProperty('display');
            row.style.removeProperty('opacity');
            row.removeAttribute('hidden');
            return;
          }
          row.setAttribute('data-jojo-gift-klaviyo-success', '');
          row.style.setProperty('display', 'none', 'important');
        });
      }

      apply();
      stopSuccessObserver();
      successObserver = new MutationObserver(apply);
      successObserver.observe(embed, { childList: true, subtree: true, attributes: true });
      successObserverTimer = setTimeout(stopSuccessObserver, 4000);
    }

    function markDrawSuccess() {
      if (!embed) return;
      stopSuccessObserver();
      embed.classList.remove('is-draw-error');
      embed.classList.add('is-draw-success');
    }

    function handleActStatus(actStatus) {
      suppressKlaviyoSuccess();
      showNotice(ACT_STATUS_MESSAGES[actStatus] || DEFAULT_ERROR_MESSAGE);
    }

    function setOpen(next) {
      if (!result) return;
      open = next;
      if (next) {
        result.removeAttribute('hidden');
        result.classList.add('is-open');
        document.documentElement.classList.add('jojo-gift-result-open');
        if (dialog) dialog.focus();
      } else {
        result.classList.remove('is-open');
        result.setAttribute('hidden', '');
        document.documentElement.classList.remove('jojo-gift-result-open');
        panels.forEach(function (panel) {
          panel.setAttribute('hidden', '');
        });
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }
    }

    function showResultPanel(panel) {
      if (!result || !panel || open) return;
      hideNotice();
      markDrawSuccess();
      panels.forEach(function (item) {
        if (item === panel) item.removeAttribute('hidden');
        else item.setAttribute('hidden', '');
      });
      lastFocus = document.activeElement;
      setOpen(true);
    }

    function hideResult() {
      if (!open) return;
      setOpen(false);
    }

    Array.prototype.forEach.call(closeEls, function (el) {
      el.addEventListener('click', hideResult);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && open) hideResult();
    });

    window.addEventListener('klaviyoForms', function (event) {
      var detail = event && event.detail;
      if (!detail || detail.type !== 'submit') return;
      if (formId && String(detail.formId) !== String(formId)) return;
      if (drawing) return;

      var email = getSubmittedEmail(detail, root);
      if (!email) {
        showNotice('メールアドレスを入力してください。');
        return;
      }

      drawing = true;
      hideNotice();

      drawLottery(email)
        .then(function (payload) {
          var drawResult = payload && payload.drawResult;
          if (!drawResult || Number(drawResult.code) !== 200) {
            handleActStatus(drawResult && drawResult.data ? drawResult.data.act_status : '');
            return;
          }

          var drawData = drawResult.data || {};
          var drawStatus = drawData.act_status || drawData.status;
          if (drawStatus && drawStatus !== 'ok') {
            handleActStatus(drawStatus);
            return;
          }

          if (!panels.length) {
            handleActStatus('');
            showNotice('抽選結果の表示設定が見つかりません。');
            return;
          }

          var panel = resolvePrizePanel(panels, drawData);
          if (panel) {
            showResultPanel(panel);
          } else {
            handleActStatus('');
          }
        })
        .catch(function (error) {
          var errorStatus = error && error.message ? String(error.message) : '';
          if (ACT_STATUS_MESSAGES[errorStatus]) {
            handleActStatus(errorStatus);
            return;
          }
          console.error('[jojo-campaign-gift] draw failed', error);
          handleActStatus('');
        })
        .finally(function () {
          drawing = false;
        });
    });
  }

  function bindHeroVideoModal(root) {
    var modal = root.querySelector('[data-jojo-gift-video-modal]');
    if (!modal) return;

    var player = modal.querySelector('[data-jojo-gift-video-player]');
    var openers = root.querySelectorAll('[data-jojo-gift-video-open]');
    if (!player || !openers.length) return;

    var lastFocus = null;
    var isOpen = false;

    function lockScroll(lock) {
      document.documentElement.classList.toggle('jojo-gift-video-open', lock);
    }

    function closeModal() {
      if (!isOpen) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      isOpen = false;
      player.removeAttribute('src');
      lockScroll(false);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    function openModal(trigger) {
      var youtubeId = trigger
        ? String(trigger.getAttribute('data-youtube-id') || '').trim()
        : '';
      if (!youtubeId || isOpen) return;

      var ratio = trigger
        ? String(trigger.getAttribute('data-video-ratio') || '').trim()
        : '';
      var dialog = modal.querySelector('.jojo-campaign-gift__video-dialog');
      if (dialog) dialog.classList.toggle('is-portrait', ratio === 'portrait');

      lastFocus = trigger || document.activeElement;
      player.src =
        'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      isOpen = true;
      lockScroll(true);

      var closeBtn = modal.querySelector('.jojo-campaign-gift__video-close');
      if (closeBtn) closeBtn.focus();
    }

    Array.prototype.forEach.call(openers, function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(btn);
      });
    });

    modal.addEventListener('click', function (event) {
      var closeEl = event.target.closest('[data-jojo-gift-video-close]');
      if (closeEl && modal.contains(closeEl)) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) closeModal();
    });
  }

  function init(root) {
    if (!root || root.dataset.jojoGiftReady === 'true') return;
    root.dataset.jojoGiftReady = 'true';
    bindTermsGate(root);
    bindResultModal(root);
    bindHeroVideoModal(root);
  }

  function boot() {
    document.querySelectorAll('[data-jojo-campaign-gift]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var root = section.querySelector('[data-jojo-campaign-gift]');
    if (root) {
      root.dataset.jojoGiftReady = 'false';
      var embed = root.querySelector('.jojo-campaign-gift__embed');
      if (embed) embed.dataset.jojoGiftGateReady = 'false';
      lotteryTokenPromise = null;
      lotteryTokenEmail = '';
      init(root);
    }
  });
})();
